<template>
	<form v-on:submit.prevent="validateBeforeSubmit">
		<div class="form-group">
			<ejs-combobox v-model="user" id="user" :dataSource='dataSourceUsers' :fields='fieldsSourceUsers' :showPopupButton='true' cssClass="e-outline" :placeholder="$t('textReports.textFormUser')" suggestionCount="10000"></ejs-combobox>
		</div>
		<div class="row">
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<ejs-datepicker v-model="dateMin" :max="dateMax" start='Decade' :placeholder="$t('textReports.textFormStartdate')"></ejs-datepicker>
				</div>
			</div>
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<ejs-datepicker v-model="dateMax" :min="dateMin" start='Decade' :placeholder="$t('textReports.textFormFinaldate')"></ejs-datepicker>
				</div>
			</div>
		</div>
		<ejs-progressbutton type='submit' cssClass="e-primary" ref="progressBtn" :disabled="disabledButton" :spinSettings="spinSettings" :progress="progress" :duration="50000">{{ $t('textBtn.btnSearch') }}</ejs-progressbutton>
	</form>
</template>

<script>
import axios from 'axios'
export default {
	name: "reports-form-user-access",
	props: ['tittle'],
	data(){
		return {
			user : null,
			dateMin :null,
			dateMax :null,
			dataSourceUsers: [],
			fieldsSourceUsers: { text: "name", value: 'id' },
			spinSettings: { position: 'Right', width: 20 },
			disabledButton :false,
			responseReport: false,
			activeFilters: []
		}
	},
	methods: {
		initFormUserAccess: function() {
			this.dataSourceUsers = [];
			axios.post('/auth/reports/getInitFormAccomplishment').then(response => {
				this.dataSourceUsers = response.data.users;
			});
		},
		validateBeforeSubmit: function() {
			this.disabledButton = true;
			this.responseReport = false;
			this.$refs.progressBtn.enable;

			var userSelect = document.getElementById('user').ej2_instances[0].itemData;

			axios.post('/auth/reports/getReportsUserAccess', {
				user: this.user,
				dateMin: this.dateMin,
				dateMax: this.dateMax
			}).then(response => {
				if(this.user    !== null && this.user    !== "")  this.activeFilters.push('Usuario - ' + userSelect.name);
				if(this.dateMin !== null && this.dateMin !== "")  this.activeFilters.push('Desde - ' + this.dateMin.toISOString().substring(0, 10)); 
				if(this.dateMax !== null && this.dateMax !== "")  this.activeFilters.push('Hasta - ' + this.dateMax.toISOString().substring(0, 10));

				this.responseReport = true;
				Vue.prototype.$eventHub.$emit('loadDataReports', this.$props.tittle, response.data, this.activeFilters.join(' / '));
			});
		},
		progress: function() {
			if(this.responseReport){
				this.$refs.progressBtn.stop();
			}
      }
	},
	created: function() {
    	this.initFormUserAccess();
      this.$eventHub.$on('onResetSwitchTenants', this.initFormUserAccess);
  	}
}
</script>